var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 880",
    style: {
      enableBackground: "new 0 0 2000 880"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1434CB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 759 140.961 L 507.63 740.72 L 343.63 740.72 L 219.93 262.083 C 212.421 232.604 205.889 221.804 183.051 209.383 C 145.76 189.151 84.18 170.172 30 158.39 L 33.679 140.961 L 297.67 140.961 C 331.319 140.961 361.57 163.361 369.209 202.111 L 434.541 549.163 L 596 140.951 L 759 140.951 L 759 140.961 Z M 1401.581 544.903 C 1402.24 386.608 1182.7 377.887 1184.211 307.175 C 1184.68 285.655 1205.17 262.774 1250.02 256.934 C 1272.25 254.024 1333.5 251.804 1402.97 283.774 L 1430.221 156.59 C 1392.891 143.041 1344.86 130 1285.101 130 C 1131.75 130 1023.83 211.522 1022.921 328.256 C 1021.931 414.599 1099.949 462.781 1158.731 491.471 C 1219.201 520.853 1239.491 539.733 1239.259 566.015 C 1238.829 606.245 1191.03 624.007 1146.36 624.705 C 1068.38 625.906 1023.129 603.605 987.06 586.834 L 958.941 718.229 C 995.19 734.86 1062.101 749.37 1131.469 750.1 C 1294.46 750.1 1401.08 669.588 1401.581 544.903 M 1806.52 740.72 L 1950.009 740.72 L 1824.759 140.961 L 1692.321 140.961 C 1662.539 140.961 1637.419 158.301 1626.301 184.962 L 1393.49 740.72 L 1556.401 740.72 L 1588.739 651.136 L 1787.789 651.136 L 1806.52 740.72 Z M 1633.409 528.214 L 1715.07 303.026 L 1762.069 528.214 L 1633.409 528.214 Z M 980.669 140.961 L 852.381 740.72 L 697.24 740.72 L 825.58 140.961 L 980.669 140.961 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.96655654c1291305e17bd023ed9002f9.svg";
export { ForwardRef as ReactComponent };